class ProductComponent extends HTMLElement {
  constructor() {
    super();
    this.productData = null;
  }

  connectedCallback() {
    this.fetchProductData();
  }

  fetchProductData() {
    const handle = this.dataset.handle;

    if (!handle) return;

    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(json => {
        this.productData = json;
        this.dispatchEvent(
          new CustomEvent('product:loaded', { detail: json })
        );
      })
      .catch(err => console.error('Product JSON load error:', err));
  }
}

customElements.define('product-component', ProductComponent);
